import { defineStore } from 'pinia'
import { ref } from 'vue'
import PermissaoService from '@/services/admin/PermissaoService'
import type { MenuItemResponse } from '@/services/admin/PermissaoService'

export const usePermissaoStore = defineStore('permissao', () => {
  const menuItems = ref<MenuItemResponse[]>([])
  const rotasPermitidas = ref<string[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const loaded = ref(false)

  const carregarMenu = async (perfilIds: number[]) => {
    if (!perfilIds.length) return
    isLoading.value = true
    error.value = null
    try {
      menuItems.value = (await PermissaoService.getMenu(perfilIds)) || []
      rotasPermitidas.value = (await PermissaoService.getRotasPermitidas(perfilIds)) || []
      loaded.value = true
    } catch (err: any) {
      error.value = err.response?.data?.mensagem || err.message || 'Erro ao carregar menu'
      console.error('Erro ao carregar menu:', err)
      menuItems.value = []
      rotasPermitidas.value = []
    } finally {
      isLoading.value = false
    }
  }

  const temAcesso = (rota: string): boolean => {
    return rotasPermitidas.value.includes(rota)
  }

  const limpar = () => {
    menuItems.value = []
    rotasPermitidas.value = []
  }

  return {
    menuItems,
    rotasPermitidas,
    isLoading,
    error,
    loaded,
    carregarMenu,
    temAcesso,
    limpar,
  }
})
